import * as React from "react";
import * as __intl__ from "@frameio/i18n";
export type Text = {
    cancel: string;
    title: (hasProjectNotificationsEnabled: boolean | null | undefined) => string | React.ReactNode;
    details: (hasProjectNotificationsEnabled: boolean | null | undefined) => string | React.ReactNode;
    confirm: (hasProjectNotificationsEnabled: boolean | null | undefined) => string | React.ReactNode;
};
export type Deps = {};
export default {
    DEFINE(_messages: Text, {}: Deps = {}): void {
        return Object.defineProperties(this, {
            /** Secondary action label to dismiss the warning dialog */
            cancel: {
                get() {
                    return __intl__.withIntl(this[__intl__.BOUND_INTL] ?? __intl__.getIntl(), () => __intl__.intl().formatMessage({ id: "WorkspaceNotificationsWarningModal.cancel?c=2ojhd8rzicmo0", defaultMessage: "Cancel" }));
                },
                enumerable: true,
                configurable: true
            },
            /** Dialog title for enabling/disabling notifications across projects */
            title: {
                get() {
                    return __intl__.withIntl(this[__intl__.BOUND_INTL] ?? __intl__.getIntl(), () => (hasProjectNotificationsEnabled: boolean | null | undefined) => __intl__.intl().formatMessage({ id: "WorkspaceNotificationsWarningModal.title?c=2p3oqb2afuouh", defaultMessage: "{hasProjectNotificationsEnabled, select, true {Disable Notifications for All Projects?} other {Enable Notifications for All Projects?}}" }, { hasProjectNotificationsEnabled: hasProjectNotificationsEnabled }));
                },
                enumerable: true,
                configurable: true
            },
            /** Dialog body text describing the impact on all projects */
            details: {
                get() {
                    return __intl__.withIntl(this[__intl__.BOUND_INTL] ?? __intl__.getIntl(), () => (hasProjectNotificationsEnabled: boolean | null | undefined) => __intl__.intl().formatMessage({ id: "WorkspaceNotificationsWarningModal.details?c=26sh6c8s6ll12", defaultMessage: "{hasProjectNotificationsEnabled, select, true {New projects in this Workspace will also have notifications disabled. You\u2019ll still be notified when you\u2019re @mentioned or assigned.} other {New projects in this Workspace will also have notifications enabled.}}" }, { hasProjectNotificationsEnabled: hasProjectNotificationsEnabled }));
                },
                enumerable: true,
                configurable: true
            },
            /** Primary action label to confirm the change */
            confirm: {
                get() {
                    return __intl__.withIntl(this[__intl__.BOUND_INTL] ?? __intl__.getIntl(), () => (hasProjectNotificationsEnabled: boolean | null | undefined) => __intl__.intl().formatMessage({ id: "WorkspaceNotificationsWarningModal.confirm?c=19igla6c0carm", defaultMessage: "{hasProjectNotificationsEnabled, select, true {Disable} other {Enable}}" }, { hasProjectNotificationsEnabled: hasProjectNotificationsEnabled }));
                },
                enumerable: true,
                configurable: true
            }
        });
    }
} as Text & {
    DEFINE(messages: Text, deps?: Deps): void;
};
